import * as userApi from '../../api/userApi'
import utils from '../../common/utils'
import { ALPN_ENABLED } from 'constants';

//demo
const state = {
	user: {},
	loginResult: {
		status: false,
		time: 0,
		message: ''
	},
	userInfo: {},
	forgetPwd: {
		imgCodeResult: {
			Status: false,
			Data: '',
			Message: ''
		},
		smsCodeResult: {
			Status: false,
			Data: '',
			Message: ''
		},
		fpResult: {
			Status: false,
			Message: ''
		}
	},
	checkRegiestMobileResult:{Status: false,	Message: ''},
	pisenResult:{Status: false,	Message: ''},
	setUserMenusResult:{Status: false,	Message: ''},
	agreePolicy: {},
}

const getters = {
	user: state => {
		let user = state.user;
		if (!!user) {
			user = JSON.parse(utils.getLS('user') || null);
		}
		return user;
	}
}

const actions = {
	async login({ commit }, input) {
		const response = await userApi.Login(input);
		commit('login', response)
	},
	async register({ commit }, input){
		const response = await userApi.Register(input);
		if(!!response){
			commit('setRegistResult',response)
		}
	},
	async forgetPwd({commit},input) {
		const response = await userApi.ForgetPwd(input);
		commit('setFpMessage', response);
	},
	async getImgVerifyCode({commit},mobile) {
		const response = await userApi.GetImgVerifyCode(mobile);
		commit('setImageResult', response);
	},
	async getSmsVerifyCode({commit},input){
		const response = await userApi.GetSmsVerifyCode(input);
		if(!!response){
			commit('setSendResult',response)
		}
	},
	async logout({ commit }) {
		const response = await userApi.Logout();
		commit('logout', response);
	},
	async getUser({ dispatch, commit }) {
		let userInfo = JSON.parse(utils.getLS('user') || null);
		if (!!userInfo) {
			let timeStamp = (new Date()).valueOf();
			commit('login', {Status: true, Data: userInfo});

			if (timeStamp >= parseFloat(userInfo.ExpireTime)) {
				const response = await userApi.RefreshToken(userInfo.Token);
				if (typeof (response) == "undefined" || !response.Status) {
					dispatch('logout');
				}
			}
		}
	},
	async getuserInfo({ commit }) {
		const response = await userApi.GetUserInfo();
		commit('getuserInfo',response);
	},
	async getImgVerifyCodeForRegister({commit},mobile) {
		const response = await userApi.GetImgVerifyCodeForRegister(mobile);
		commit('setImageResult', response);
	},
	async getSmsVerifyCodeForRegister({commit},input){
		const response = await userApi.GetSmsVerifyCodeForRegister(input);
		if(!!response){
			commit('setSendResult',response)
		}
	},
	async checkRegiestMobile({commit},input){
		const response = await userApi.CheckRegiestMobile(input);
		if(!!response){
			commit('setCheckRegiestMobileResult',response)
		}
	},
	async getUserMenus({commit},input){
		const response = await userApi.GetUserMenus(input);
		if(response.Status){
			commit('setUserMenusResult',response)
		}
	},
	async GetSSOLoginUrl({ commit }, input) {
		const response = await userApi.GetSSOLoginUrl(input);
	
		commit('GetSSOLoginUrl', response)
	},
	async LoginCallBack({ commit }, input) {
		const response = await userApi.LoginCallBack(input);
	
		commit('LoginCallBack', response)
	},
	async UnBind({ commit }, input) {
		const response = await userApi.UnBind(input);
	
		commit('UnBind', response)
	},
	async ClearSession({ commit }, input) {
		const response = await userApi.ClearSession(input);
	
		commit('ClearSession', response)
	},
	async GetPolicy({commit}, input) {
		const response = await userApi.GetPolicy(input);
		return response;
	},
	AppLogin({commit},data){
		commit('appLogin',data);
	}
}

const mutations = {
	login(state, account) {
		if (account.Status) {
			state.user = account.Data;
			state.loginResult.status = true;
			utils.setLS('user', JSON.stringify(account.Data));
		} else {
			state.user = {};
			state.loginResult.status = false;
			state.loginResult.message = account.Message;
			utils.removeLS('user');
		}
		state.loginResult.time = (new Date()).valueOf();
	},
	appLogin(state,data){
		state.user = data.Data;
		state.loginResult.status = data.Status;
		state.loginResult.time = (new Date()).valueOf();
	},
	GetSSOLoginUrl(state, result) {//获取登录地址
		window.location.href=result.Data;
	},
	LoginCallBack(state, result) {//登录回调
		 if(result.Status)
		 {
			state.user = result.Data;
		 	state.loginResult.status = true;
			 utils.setLS('user', JSON.stringify(result.Data));
			 window.location.href=result.Data.Url;
		 }
		 else{
		 	state.user = {};
		 	state.loginResult.status = false;
		 	state.loginResult.message = result.Message;
			utils.removeLS('user');
			this.$layer.msg(result.Message || "系统错误");
		 }
		state.loginResult.time = (new Date()).valueOf();
		
	},
	UnBind(state, data) {//解除绑定
		state.user = {};
		state.loginResult.status = false;
		state.loginResult.time = (new Date()).valueOf();
		state.loginResult.message = data.Message;
		utils.removeLS('user');
		
		window.location.href=data.Data;
	},
	ClearSession(state, result) {//清除WEBApi服务缓存
			state.user = {};
			state.loginResult.status = false;
			state.loginResult.time = (new Date()).valueOf();
			state.loginResult.message = result.Message;
			utils.removeLS('user');
	},
	setImageResult(state, data) {
		state.forgetPwd.imgCodeResult = data;
	},
	setSendResult(state, data) {
		state.forgetPwd.smsCodeResult = data;
	},
	setFpMessage(state, data) {
		state.forgetPwd.fpResult = data;
	},
	logout(state, data) {
		state.user = {};
		state.loginResult.status = false;
		state.loginResult.time = (new Date()).valueOf();
		state.loginResult.message = data.Message;
		utils.removeLS('user');
	},
	getuserInfo(state, data) {
		if (!!data && data.Status) {
			state.userInfo = data
		}
	},
	setCheckRegiestMobileResult(state, data){
		if (!!data) {
			state.checkRegiestMobileResult = data
		}
	},
	setRegistResult(state,data){
		state.pisenResult = data
	},
	setUserMenusResult(state,data){
		state.setUserMenusResult = data;
		console.log(data)
	},
}

export default {
	namespaced: true,
	getters,
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js